import { useEffect, useCallback } from 'react'
import { dispatch, state } from 'store'
import socketIOClient from 'socket.io-client'
import { handleDatagridSocketCells, handleDatagridSocketGridSingle } from '../tailwindui/pages/datagrid/api'
import { checkSheetData, checkCellData } from '../api/sheets'
import { handleBroadcastMessage } from 'utils/socketUtils'
import { useLocation, useParams } from 'react-router'
let socket

let pingInterval
const validTableId = (tableId) => {
    const sheets = state().sheets.sheets
    const sheet = sheets.find(s => s._id === tableId)
    return !!sheet
}
const cellUpdates = {};


const handleCellUpdate = (msg) => {
    if (msg && msg.tableId && msg.rowId && msg.cellId && validTableId(msg.tableId)) {
        const key = `${msg.tableId}:${msg.rowId}:${msg.cellId}`
        // Include timestamp in the cell update data if available
        cellUpdates[key] = {
            rowId: msg.rowId,
            cellId: msg.cellId,
            value: msg.message,
            tableId: msg.tableId,
            timestamp: msg.timestamp || new Date().getTime()
        }
    }
}
const onRunComplete = (msg) => {
    if (msg && msg.tableId && msg.rowId && msg.cellId && validTableId(msg.tableId)) {
        setTimeout(() => {
            checkCellData(msg.tableId, msg.rowId, msg.cellId)
        }, 5000)
    }
}

const setCurrentTable = (pathname, id, socket) => {
    if (socket && id && pathname) {
        if (socket && pathname.includes('/dashboard/table/') && id && `/dashboard/table/${id}` === pathname) {
            socket.emit('current_table', id)
        }
    } else if (socket) {
        socket.emit('current_table', null)

    }
}
const WebSocket = (user) => {
    const { pathname } = useLocation()
    const { id } = useParams()
    const token = localStorage.getItem('accessToken')
    const userId = user._id
    const checkSocketConnection = useCallback(() => {
        if (socket && !socket.connected) {
            socket.connect()
        }
    }, [])
    const pingpong = useCallback((id) => {
        if (pingInterval) {
            clearInterval(pingInterval)
        }
        if (id) {
            pingInterval = setInterval(() => {
                if (socket.connected) {
                    const url = window.location.href
                    const [_, tableId] = url.split('/dashboard/table/')
                    const [pureTableId, __] = (tableId ?? '').split('/')
                    socket.emit('ping', { socketId: id, userId: userId, tableId: pureTableId })
                } else {
                    dispatch({ type: 'SOCKET_CONNECTED', payload: false })
                }
            }, 6000) // Send ping every minute
        }
    }, [userId])
    const init = useCallback(async () => {
        // Configure socket with auth
        socket = socketIOClient.connect(process.env.REACT_APP_API_URL, {
            auth: {
                userId,
                token
            },
            autoConnect: true,
            reconnection: true,
            reconnectionAttempts: 5, // Number of attempts before giving up
            reconnectionDelay: 3000, // Time to wait between attempts (1 second)
            reconnectionDelayMax: 5000, // Max delay (5 seconds)
            timeout: 20000, // Time before the connection attempt times out (20 seconds)
        })
        socket.on('connect', () => {
            dispatch({ type: 'SOCKET_CONNECTED', payload: true })
            socket.emit('register', userId);
            pingpong(socket.id)
            socket.on('broadcast_message', (data) => {
                handleBroadcastMessage(data)
            })
            socket.on('login_OTP', (data) => {
                dispatch({ type: 'LOGIN_OTP', payload: data })
                return null
            })
            socket.on('CELL_UPDATES', (data) => {
                console.log('CELL_UPDATES', data)
                dispatch({ type: 'CELL_UPDATES_V2', payload: data })
                return null
            })
            socket.on('TABLE_STATS', (data) => {
                console.log('TABLE_STATS', data)
                dispatch({ type: 'STATS_UPDATES_V2', payload: data })
                return null
            })
            socket.on('private_message', (data) => {
                if (data.type === 'ADD_ROW') {
                    dispatch({ type: 'ADD_ROW_SHEET', payload: data })
                    return null
                }
                if (data.type === 'DELETE_ROW') {
                    dispatch({ type: 'DELETE_ROWS_SHEET', payload: data })
                    return null
                }
                if (data.type === 'TABLE_STATS') {
                    dispatch({ type: 'TABLE_STATS', payload: data })
                    return null
                }
                if (data.type === 'LOGIN_STATUS') {
                    dispatch({ type: 'LOGIN_STATUS', payload: data })
                    return null
                }
                if (data.type === 'UPDATE_ROW') {
                    if (data.row && data.tableId && validTableId(data.tableId)) {
                        dispatch({ type: 'UPDATE_ROW_V2', payload: data.row })
                        return null
                    }

                }
                if (data.type === 'NEW_ROW') {
                    if (data.row && data.tableId && validTableId(data.tableId)) {
                        dispatch({ type: 'NEW_ROW', payload: data.row })
                        return null
                    }

                }
                if (data.type === 'UPDATE_CELL_DATA') {
                    return handleCellUpdate(data)
                }
                if (data.type === '___Completed') {
                    return onRunComplete(data)
                }
                handleDatagridSocketGridSingle(data)
                handleDatagridSocketCells(data)
                if (data.type === 'REFRESH_TABLE') {
                    dispatch({ type: 'REFRESH_TABLE', payload: data })
                }
                if (data.type === 'REFRESH_TABLE_ROWS') {
                    checkSheetData(data)
                }
                if (data.type === 'SET_ENRICHMENT_STATUS_SHEET') {
                    dispatch({ type: 'SET_ENRICHMENT_STATUS_SHEET', payload: data })
                }
            })

            dispatch({ type: 'SET_SOCKET_ID', payload: socket.id })
            dispatch({ type: 'SET_ROOM_ID', payload: 'private_message' })
            setCurrentTable(pathname, id, socket)
        })

        socket.on('connect_error', (error) => {
            console.log('connect_error', error)
            dispatch({ type: 'SOCKET_ERROR', payload: error.message })
            dispatch({ type: 'SOCKET_CONNECTED', payload: false })
        })

        socket.on('pong', () => {
            dispatch({ type: 'SOCKET_CONNECTED', payload: true })
        })

        socket.on('unauthorized', (error) => {
            dispatch({ type: 'SOCKET_UNAUTHORIZED', payload: error.message })
            socket.disconnect()
        })
        socket.on('reconnect_attempt', () => {
        });

        socket.on('reconnect', () => {
            if (pingInterval) {
                clearInterval(pingInterval)
            }
            pingpong(socket.id)
        });
        socket.on('disconnect', () => {
            dispatch({ type: 'SOCKET_CONNECTED', payload: false })
        });
    }, [userId, token, pingpong, id, pathname])

    // Handle visibility change to check socket connection
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkSocketConnection()
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [checkSocketConnection])

    // Ping-pong mechanism
    useEffect(() => {


        return () => {
            if (pingInterval) {
                clearInterval(pingInterval)
            }
        }
    }, [])
    useEffect(() => {
        setCurrentTable(pathname, id, socket)
    }, [pathname, id,])

    useEffect(() => {
        if (userId && token) {
            init()
        } else {
        }

        return () => {
            if (socket) {
                socket.disconnect()
                dispatch({ type: 'CLEANUP_SOCKET' })
            }
            // clearInterval(cl)
        }
    }, [userId, token, init])

    return {
        socket
    }
}
export default WebSocket
